export default __webpack_public_path__ + "static/media/teachersdashboard.38dd5244.png";